import { IOperator } from '@entities/operator';

export default function (operator: IOperator | null, _takenOperators: IOperator['id'][]): boolean {
    if (!_takenOperators.length) return true;
    if (!operator) return false;
    return _takenOperators.includes(operator.id);
}